import React from "react";

const SummaryCards = ({ totalRevenue, firstTransactionDate, totalTransactions, countriesCount, paymentMethodsCount }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(new Date(dateString));
  };

  return (
    <div className="space-y-6 mb-8">
      {/* Total Revenue Card - Full Width */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h3 className="text-xl font-semibold mb-3">Total Revenue</h3>
        <p className="text-5xl font-bold text-green-600">{formatCurrency(totalRevenue)} ✊</p>
        {firstTransactionDate && (
          <p className="text-lg mt-2">Since {formatDate(firstTransactionDate)}</p>
        )}
      </div>

      {/* Other Stats - 3 Column Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Total Transactions</h3>
          <p className="text-3xl font-bold text-blue-600">{totalTransactions || 0}</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Countries</h3>
          <p className="text-3xl font-bold text-purple-600">{countriesCount || 0}</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Payment Methods</h3>
          <p className="text-3xl font-bold text-green-600">{paymentMethodsCount || 0}</p>
        </div>
      </div>
    </div>
  );
};

export default SummaryCards;
